export default class OpenMode {
	static NESTED_WINDOW = 'show.nested.window';
	static NEW_BROWSER_TAB = 'open.in.new.tab';
	static SAME_BROWSER_TAB = 'open.link.in.same.window';
	static NEW_CJ_TAB = 'new.cj.tab';
	static SAME_CJ_TAB = 'open.in.same.cj.tab';
}
